import ArticleLayout from '@/components/feature/ArticleLayout';
import { articoloAlternative } from '@/mocks/articles';

export default function AlternativePage() {
  return <ArticleLayout article={articoloAlternative} />;
}